import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { content } from "./content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "sv";
    const stored = window.localStorage.getItem("livon-lang");
    if (stored === "sv" || stored === "en") return stored;
    // Default to SV for the Swedish LIVON brand; only switch to EN if the
    // browser language is clearly English.
    const nav = (navigator.language || "sv").toLowerCase();
    return nav.startsWith("en") ? "en" : "sv";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("livon-lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggle: () => setLang((l) => (l === "sv" ? "en" : "sv")),
      t: content[lang],
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
